/**
 * As regras do Início (explore/HomeState.tsx): a saudação da hora, os sistemas mais jogados e o que
 * acontece ao clicar numa mesa. Funções puras, para os testes.
 */
import { systemKey, type RoomCard } from '../shared.js';

/** "Bom dia" das 5 às 11, "Boa tarde" das 12 às 17, "Boa noite" no resto. */
export function greetingKey(hour: number): string {
  if (hour >= 5 && hour < 12) return 'home.greeting.morning';
  if (hour >= 12 && hour < 18) return 'home.greeting.afternoon';
  return 'home.greeting.evening';
}

/**
 * Os sistemas mais usados entre as mesas públicas: "D&D 5e" e "d&d  5E" contam juntos (`systemKey`,
 * o mesmo do filtro do Explorar), e o chip mostra a grafia mais comum. Empate na contagem vai pela
 * ordem alfabética.
 */
export function topSystems(cards: readonly Pick<RoomCard, 'isPrivate' | 'rpgSystem'>[], n = 5): string[] {
  const groups = new Map<string, { total: number; spellings: Map<string, number> }>();
  for (const card of cards) {
    if (card.isPrivate) continue;
    const spelling = card.rpgSystem.trim().replace(/\s+/g, ' ');
    if (!spelling) continue;
    const key = systemKey(spelling);
    const group = groups.get(key) ?? { total: 0, spellings: new Map<string, number>() };
    group.total += 1;
    group.spellings.set(spelling, (group.spellings.get(spelling) ?? 0) + 1);
    groups.set(key, group);
  }
  return [...groups.values()]
    .map((group) => ({ total: group.total, name: [...group.spellings].sort((a, b) => b[1] - a[1] || a[0].localeCompare(b[0]))[0]![0] }))
    .sort((a, b) => b.total - a.total || a.name.localeCompare(b.name))
    .slice(0, n)
    .map((system) => system.name);
}

/**
 * Clicar numa mesa do Início: voltar a ela se já está aberta nesta aba, pedir a senha (pela visão
 * geral) se ela tem uma e quem olha não é dono nem mestre auxiliar, ou entrar direto.
 * O servidor pede a senha em toda entrada, não só na primeira.
 */
export type EnterAction = 'back' | 'password' | 'join';
export function enterAction(card: Pick<RoomCard, 'id' | 'ownerId' | 'amIAuxGm' | 'hasPassword'>, meId: string | undefined, openRoomIds: readonly string[]): EnterAction {
  if (openRoomIds.includes(card.id)) return 'back';
  if (card.hasPassword && card.ownerId !== meId && !card.amIAuxGm) return 'password';
  return 'join';
}
